const html = require("./html/asnDetailRowsView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import AsnDetailRowView from "./AsnDetailRowView";

const elementsMap = {
  asnDetailRowsOuter: ".shipping-asn-details-rows-outer",
  casePalletTitle: ".case-pallet-title"
}
 
export default function AsnDetailRowsView(_unused, {
  getAsn,
  getAsnDetailGroups,
  onLengthChange, 
  onWidthChange,
  onHeightChange,
  onWeightChange,
  onAsnDetailGroupFieldChange,
  onAsnFieldChange,
  readOnly,
  isPallet
}){
  const self = this;
  self._element = $();
  const els = {};
  let asnDetailRowViews = [];

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){

  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
    updateChildren();
  }

  function updateSelf(){
    updateCasePalletLabel();
  }

  function updateCasePalletLabel(){
    let text = "Case";
    if(isPallet()){
      text = "Pallet";
    }
    els.casePalletTitle.text(text);
  }


  function updateChildren(){
    unbindAll(asnDetailRowViews);
    asnDetailRowViews = renderAsnDetailRowViews();
    els.asnDetailRowsOuter.html(extractElements(asnDetailRowViews));
  }


  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", update);
    AsnDetailStore.bindListener("asn_details:add", update);
    AsnDetailStore.bindListener("asn_details:remove", update);
    AsnStore.bindListener("asns:change", updateSelf);
  }

  self.unbindListeners = function(){

  }


  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindStores();
  }

  function renderAsnDetailRowViews(){
    return _(getAsnDetailGroups()).map((asnDetailGroup, rowIdx)=>{
      // get the first asnDetail in the Pallet/case,
      // as all these values should be the same for the given
      // AsnDetailRowView
      const asnDetail = asnDetailGroup[0];
      const asnDetailRowView = new AsnDetailRowView(asnDetail, {
        readOnly,
        // onLengthChange, 
        // onWidthChange,
        // onHeightChange,
        // onWeightChange,
        onAsnDetailGroupFieldChange,
        rowIdx,
        isPallet,
        getAsnDetailGroups
      });
      asnDetailRowView.init();
      return asnDetailRowView;
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/AsnDetailRowsView.js